const _ = require('lodash')

// const getCookie = (cname) => {
//   var name = cname + '='
//   var decodedCookie = decodeURIComponent(document.cookie)
//   var ca = decodedCookie.split(';')
//   for(var i = 0; i <ca.length; i++) {
//     var c = ca[i]
//     while (c.charAt(0) == ' ') {
//       c = c.substring(1)
//     }
//     if (c.indexOf(name) == 0) {
//       return c.substring(name.length, c.length)
//     }
//   }
//   return ''
// }

const getCookie = (cname) => {
  var name = cname + '='
  var decodedCookie = decodeURIComponent(document.cookie)
  var ca = decodedCookie.split(';')
  if(ca.length>0){
    var c = ca[ca.length > 1 ? ca.length-2 : ca.length-1]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  else
    return ""
}

const getValueByLang = (language = 'th-TH') => (data = {}, propsName = 'name', defaultValue = '') => {
  const langPrefix = language.includes('th') ? '_th' : '_en'
  return _.get(data, `${propsName}${langPrefix}`, defaultValue)
}

const getCurrentLang = () => {

  if(getCookie('i18next') !== undefined) 
    return getCookie('i18next')
  else if(getCookie('i18next') !== undefined) 
    return getCookie('i18nextLng')
  else if(localStorage['i18next'] !== undefined)
    return localStorage['i18next']
  else
    return localStorage['i18nextLng']
    
}

module.exports = {
  getValueByLang,
  getCurrentLang,
}
